import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";

export default function NewComersCountReport() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchData("chaat/members/reports/new_comers?count")
      .then(data => setCount(data.data))
      .catch(err => setError(err.message || "حدث خطأ أثناء جلب البيانات"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white rounded-xl shadow p-6 mb-6">
      <h2 className="font-bold text-xl mb-4">عدد الأعضاء الجدد</h2>
      {loading && <div className="text-center">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center">{error}</div>}
      {count !== null && !loading && !error && (
        <div className="text-4xl font-bold text-green-600 text-center">{count}</div>
      )}
    </div>
  );
}
